<template>
	<div class="appMain" id="appMain">
		<transition name="fade-transform" mode="out-in">
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
				<router-view v-if="!$route.meta.keepAlive"></router-view>
			</keep-alive>
		</transition>
	</div>
</template>
<script>
export default {
	computed: {}
}
</script>
<style lang="scss" scoped>
.appMain {
	min-height: calc(100vh - 142px);
	background-color: #fff;
	border-radius: 10px;
}
</style>
